module.exports = __webpack_public_path__ + "img/student3.fd7a42a6.jpg";